import { fetch as tauriFetch } from "@tauri-apps/plugin-http";

import type { MarketQuoteGateway } from "../application/marketQuoteGateway";
import { createFetchMarketQuoteGateway } from "../persistence/fetchMarketQuoteGateway";
import { isTauriRuntime } from "./appSurface";

export const TAURI_MARKET_QUOTE_ENDPOINT =
  "https://banryeojusik-dev.kimhighstar.workers.dev/api/quotes";
export const TAURI_MARKET_INSTRUMENT_SEARCH_ENDPOINT =
  "https://banryeojusik-dev.kimhighstar.workers.dev/api/quotes/search";

export function createRuntimeMarketQuoteGateway(): MarketQuoteGateway | undefined {
  if (isTauriRuntime()) {
    return createFetchMarketQuoteGateway({
      endpoint: TAURI_MARKET_QUOTE_ENDPOINT,
      searchEndpoint: TAURI_MARKET_INSTRUMENT_SEARCH_ENDPOINT,
      fetch: tauriFetch as typeof globalThis.fetch,
    });
  }
  return import.meta.env.PROD
    ? createFetchMarketQuoteGateway()
    : undefined;
}
